import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const ReportIncidentButton = ({ projectLineId }) => {
    const history = useHistory();
    const { t } = useTranslation();

    return (
        <Button
            variant="outlined"
            fullWidth
            color="error"
            onClick={() => {
                history.push(`/report/incident/${projectLineId}`);
            }}
        >
            {t("ReportIncident")}
        </Button>
    );
};

export default ReportIncidentButton;
